import styled from 'styled-components'

const Card = styled.div`
    background: #ABFE2C78;
    padding: 1.5em 1.5em 1.5em 1.5em;
    border-radius: 1em;
`

export default Card